// @flow

export const USERNAME_PASSWORD_LOGIN_METHOD = "username-password-login-method";
export const ACCESS_CODE_LOGIN_METHOD = "access-code-login-method";

export type Preferences = {
  loginMethod: string,
  timeZone: number
};
